import React from "react";

import Grid from "@mui/material/Grid";

import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import BlockRoundedIcon from "@mui/icons-material/BlockRounded";
import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";

import DashboardCard from "./DashboardCard";

import { useTranslation } from "react-i18next";

const EmployeeStatistics = ({ rows = [] }) => {
  const { t } = useTranslation("UserManagement");

  const totalEmployees = rows.length;

  const activeEmployees = rows.filter((x) => !x.isInactive).length;

  const inactiveEmployees = rows.filter((x) => x.isInactive).length;

  const totalDepartments = new Set(
    rows.map((x) => x.department).filter(Boolean),
  ).size;

  return (
    <Grid container spacing={3} mb={3}>
      {/* Total Employees */}
      <Grid item xs={12} sm={6} md={3}>
        <DashboardCard
          title={t("Employees")}
          value={totalEmployees}
          icon={<PeopleAltRoundedIcon />}
        />
      </Grid>

      {/* Active */}
      <Grid item xs={12} sm={6} md={3}>
        <DashboardCard
          title={t("Active")}
          value={activeEmployees}
          color="success.main"
          icon={<CheckCircleRoundedIcon />}
        />
      </Grid>

      {/* Inactive */}
      <Grid item xs={12} sm={6} md={3}>
        <DashboardCard
          title={t("Inactive")}
          value={inactiveEmployees}
          color="error.main"
          icon={<BlockRoundedIcon />}
        />
      </Grid>

      {/* Departments */}
      <Grid item xs={12} sm={6} md={3}>
        <DashboardCard
          title={t("Departments")}
          value={totalDepartments}
          color="warning.main"
          icon={<ApartmentRoundedIcon />}
        />
      </Grid>
    </Grid>
  );
};

export default EmployeeStatistics;
